import { isUndefined } from 'lodash';
import { AccessorNode, ArrayNode, ConstantNode, MathNode, ObjectNode, ParenthesisNode, SymbolNode } from 'mathjs';

interface ArgsNode extends MathNode {
  args: MathNode[];
}

export const getSymbols = (node: MathNode, symbols: Set<string>) => {
  if (isUndefined(node)) {
    throw new Error('node is undefined');
  }
  if ((node as SymbolNode).isSymbolNode) {
    symbols.add((node as SymbolNode).name as string);
  } else if ((node as ConstantNode).isConstantNode) {
    return undefined;
  } else if ((node as ParenthesisNode).isParenthesisNode) {
    getSymbols((node as ParenthesisNode).content, symbols);
  } else if ((node as ArrayNode).isArrayNode) {
    (node as ArrayNode).items?.forEach(item => {
      getSymbols(item, symbols);
    });
  } else if ((node as AccessorNode).isAccessorNode) {
    const accessorSet = new Set<string>();
    getSymbols((node as AccessorNode).object, accessorSet);
    const accessorSymbolArr = Array.from(accessorSet);
    accessorSymbolArr.push((node as AccessorNode).name as string);
    symbols.add(accessorSymbolArr.join('.'));
  } else if ((node as ObjectNode).isObjectNode) {
    const objectNode = node as ObjectNode;
    Object.values(objectNode.properties).forEach(item => {
      getSymbols(item, symbols);
    });
  } else {
    if (isUndefined((node as ArgsNode).args)) {
      throw new Error('implementation undefined for node');
    }
    (node as ArgsNode).args.forEach(arg => {
      getSymbols(arg, symbols);
    });
  }
};

export const getGetSymbolSet = (node: MathNode) => {
  const symbolSet = new Set<string>();
  getSymbols(node, symbolSet);
  return symbolSet;
};
